import { render, staticRenderFns } from "./RadialBarChart.vue?vue&type=template&id=5ee4be22"
import script from "./RadialBarChart.vue?vue&type=script&lang=js"
export * from "./RadialBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports